// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605121055/js/" + chunkId + "." + {"44":"98a2cc47","225":"06f227d0","481":"6f82c621","486":"56fb3ef6","770":"3aa65ce9"}[chunkId] + ".0.4234823038310065.chunk.js";
};